import { Schedule } from '@root/globalTypes';
import { compareHours } from '@utils/dateHelpers';
import { isAfter, isBefore, parseISO, subMinutes } from 'date-fns';

export const getSchedule = (segment: Date, segmentLength: number, data?: Schedule[]) =>
  data?.find((el) => {
    if (!el?.startsAt || !el?.endsAt) return;
    const startDate = parseISO(el.roundedStartsAt || el.startsAt);
    const endDate = subMinutes(parseISO(el.roundedEndsAt || el.endsAt), segmentLength);
    const isBeforeOrEqualEnd = isBefore(segment, endDate) || compareHours(segment, endDate);
    const isAfterOrEqualStart = isAfter(segment, startDate) || compareHours(segment, startDate);
    return isBeforeOrEqualEnd && isAfterOrEqualStart;
  });

export const isStart = (segment: Date, data?: Schedule[]) =>
  data?.some((el) => {
    if (!el?.startsAt || !el?.endsAt) return;
    const startDate = parseISO(el.roundedStartsAt || el.startsAt);
    if (compareHours(segment, startDate)) return true;
  });

export const isEnd = (segment: Date, segmentLength: number, data?: Schedule[]) =>
  data?.some((el) => {
    if (!el?.startsAt || !el?.endsAt) return;
    const endDate = subMinutes(parseISO(el.roundedEndsAt || el.endsAt), segmentLength);
    if (compareHours(segment, endDate)) return true;
  });
